/**
 * Which surface raised a mandatory two-factor enrollment gate. Drives both the
 * friendly, context-specific copy and whether the gate is hard (non-dismissable)
 * in the shared two-factor gate dialog, and lets each trigger point declare its
 * context without duplicating user-facing strings.
 *
 * - TREASURY_LOGIN: operational-Treasury org login gate for a financial-account WRITE
 *   user — hard, dashboard withheld until enrolled. Reasoning: protect the org's money.
 * - TREASURY_LOGIN_CARDHOLDER: same hard login gate for a spend CARDHOLDER (no financial
 *   write access) — the reasoning differs (protect your card), so the copy differs (SD-8330).
 * - TREASURY_KYC: pre-Treasury org launching Connect KYC — fires before
 *   verification begins; dismissable so the user can back out of setup.
 */
export enum TwoFactorGateReason
{
    TREASURY_LOGIN = 'treasuryLogin',
    TREASURY_LOGIN_CARDHOLDER = 'treasuryLoginCardholder',
    TREASURY_KYC = 'treasuryKyc',
}
